export function isPlatformSubscriberClient(client) {
  const meta = client?.metadata && typeof client.metadata === 'object' ? client.metadata : {};
  return Boolean(meta.platformSubscriberUserId);
}

export function parseSubscriberCondicionIva(condicionIva) {
  const s = String(condicionIva || '').trim();
  const m = /^Plan\s+(.+?)\s+\((mensual|anual)\)\s*·\s*(.+)$/i.exec(s);
  if (!m) return null;
  return {
    planLabel: m[1].trim(),
    cycle: m[2].toLowerCase(),
    statusKey: m[3].trim().toLowerCase(),
  };
}

const STATUS_STYLES = {
  trial: { light: 'bg-violet-100 text-violet-800', dark: 'bg-violet-900/50 text-violet-200' },
  active: { light: 'bg-emerald-100 text-emerald-800', dark: 'bg-emerald-900/50 text-emerald-200' },
  churn: { light: 'bg-gray-100 text-gray-600', dark: 'bg-gray-800 text-gray-400' },
  lead: { light: 'bg-amber-100 text-amber-800', dark: 'bg-amber-900/50 text-amber-200' },
};

export function subscriberStatusBadgeClass(statusKey, modoOscuro) {
  const k = String(statusKey || 'lead').toLowerCase();
  const palette = STATUS_STYLES[k] || STATUS_STYLES.lead;
  return modoOscuro ? palette.dark : palette.light;
}

export function getPlatformSubscriberDisplay(client) {
  if (!isPlatformSubscriberClient(client)) return null;
  const meta = client.metadata && typeof client.metadata === 'object' ? client.metadata : {};
  const parsed = parseSubscriberCondicionIva(client.condicionIva);
  const planLabel = meta.platformPlanName || parsed?.planLabel || meta.platformPlanSlug || 'Plan';
  const cycle = parsed?.cycle || 'mensual';
  const statusKey = parsed?.statusKey || 'lead';
  const statusLabels = { trial: 'Prueba', active: 'Activo', churn: 'Baja', lead: 'Lead' };
  return {
    planLabel,
    cycle,
    statusKey,
    statusLabel: statusLabels[statusKey] || statusKey,
  };
}
